import React from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Modules from './components/Modules';
import Features from './components/Features';
import ProductDetails from './components/ProductDetails';
import HowItWorks from './components/HowItWorks';
import Privacy from './components/Privacy';
import Demo from './components/Demo';
import Footer from './components/Footer';
import { BrowserRouter as Router } from 'react-router-dom';


export default function App() {
  return (
    <Router basename="/microsite/">
      <Navbar />
      <Hero />
      <Stats />
      <Modules />
      <Features />
      <ProductDetails />
      <HowItWorks />
      <Privacy />
      <Demo />
      <Footer />
    </Router>
  );
}
